import { render, staticRenderFns } from "./CardReader.vue?vue&type=template&id=2ef2f1f0&scoped=true"
import script from "./CardReader.vue?vue&type=script&lang=ts"
export * from "./CardReader.vue?vue&type=script&lang=ts"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./CardReader.vue?vue&type=style&index=1&id=2ef2f1f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef2f1f0",
  null
  
)

export default component.exports